import m from "../../geodata/es2015/bosniaHerzegovinaCantonsHigh";
window.am4geodata_bosniaHerzegovinaCantonsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/bosniaHerzegovinaCantonsHigh.js
// module id = null
// module chunks = 